/* Complete-the-look bundle hotspots — interactive variant picker.
 *
 * Each hotspot opens a rich card (image + colour swatches + size pills). A dot
 * may have TWO cards — a desktop one and a mobile one (separate mobile product);
 * the JS picks the right card by viewport. Desktop opens on hover; touch opens a
 * bottom-sheet on tap. Markup contract: sections/home-bundle.liquid +
 * snippets/bundle-card.liquid (each card carries data-card=<uid>, data-hotspot=<id>,
 * and class bundle__card--mob on the mobile variant).
 */
(function () {
  const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.querySelectorAll('[data-bundle]').forEach((root) => {
    const hotspots = Array.from(root.querySelectorAll('.bundle__hotspot'));
    const cards = Array.from(root.querySelectorAll('.bundle__card'));
    const totalEl = root.querySelector('[data-bundle-total]');
    const selectedRow = root.querySelector('[data-bundle-selected]');
    const stage = root.querySelector('.bundle__stage');
    const mobileQ = window.matchMedia('(max-width: 900px)');

    let listMul = parseFloat(root.dataset.listMultiplier || '1.12');
    if (listMul > 10) listMul = listMul / 100;

    function fmt(cents) {
      if (window.abbaraMoney) return window.abbaraMoney.format(cents);
      const amount = (cents / 100).toFixed(0);
      const grouped = Number(amount).toLocaleString();
      const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';
      return `${cur} ${grouped}`;
    }

    let open = null;        // cid of the currently-open card
    let closeTimer = null;

    /* Mobile: relocate the cards into a fixed bottom-sheet drawer. */
    let mobileCards = null;
    const moveCards = (toMobile) => {
      if (toMobile) {
        if (!mobileCards) {
          mobileCards = document.createElement('div');
          mobileCards.className = 'bundle__cards-mobile';
          stage.insertAdjacentElement('afterend', mobileCards);
          mobileCards.addEventListener('click', (e) => {
            if (e.target !== mobileCards) return;
            // The backdrop covers the stage, so a tap "outside the pop-up" may
            // actually be aimed at another dot underneath — switch to it instead
            // of closing. Any other outside tap closes as usual.
            const under = document.elementsFromPoint(e.clientX, e.clientY)
              .find((el) => el.classList && el.classList.contains('bundle__hotspot'));
            if (under) {
              const next = activeItem(under.dataset.id);
              if (next && next.cid !== open) { open = next.cid; render(); return; }
            }
            open = null; render();
          });
        }
        cards.forEach((c) => mobileCards.appendChild(c));
      } else if (mobileCards) {
        cards.forEach((c) => stage.appendChild(c));
        mobileCards.remove();
        mobileCards = null;
      }
    };
    moveCards(mobileQ.matches);
    mobileQ.addEventListener('change', (e) => { moveCards(e.matches); open = null; render(); });

    /* One entry per CARD (a hotspot may have a desktop + a mobile card). */
    const items = cards.map((card) => {
      const cid = card.dataset.card;
      const hotspotId = card.dataset.hotspot || cid;
      const hotspot = hotspots.find((h) => h.dataset.id === hotspotId) || null;
      const img = card.querySelector('[data-bundle-img]');
      const nameEl = card.querySelector('.bundle__card-name');
      let variants = null;
      const vjson = card.querySelector('[data-bundle-variants]');
      if (vjson) { try { variants = JSON.parse(vjson.textContent); } catch (_) { variants = null; } }
      return {
        cid, hotspotId, hotspot, card,
        isMob: card.classList.contains('bundle__card--mob'),
        on: false, // start empty — nothing is pre-selected; the shopper adds pieces

        name: nameEl ? nameEl.textContent.trim() : '',
        variants,
        media: card.querySelector('[data-bundle-media]'),
        img,
        priceEl: card.querySelector('[data-bundle-price]'),
        swatches: Array.from(card.querySelectorAll('[data-color]')),
        sizeEls: Array.from(card.querySelectorAll('[data-size]')),
        selColor: null, selSize: null,
        qty: 1,
        variantId: hotspot ? (hotspot.dataset.variantId || null) : null,
        priceCents: hotspot ? parseInt(hotspot.dataset.priceCents || '0', 10) : 0,
        image: img ? img.getAttribute('src') : '',
      };
    });

    // Which card-item is active for a hotspot at the current viewport.
    function activeItem(hotspotId) {
      const mob = items.find((i) => i.hotspotId === hotspotId && i.isMob);
      const desk = items.find((i) => i.hotspotId === hotspotId && !i.isMob);
      return (mobileQ.matches && mob) ? mob : (desk || mob);
    }
    const isActive = (it) => activeItem(it.hotspotId) === it;

    /* ── Picker helpers ───────────────────────────────────────────────── */
    function colorImage(it, color) {
      const sw = it.swatches.find((s) => s.dataset.color === color);
      return sw ? sw.dataset.image : '';
    }
    function variantFor(it, color, size) {
      if (!it.variants) return null;
      return it.variants.find((v) =>
        (color == null || v.color === color) && (size == null || v.size === size)) || null;
    }
    function firstAvailable(it) {
      if (!it.variants) return null;
      return it.variants.find((v) => v.available) || it.variants[0] || null;
    }
    function swapImage(it, src) {
      if (!it.img || !src || it.img.getAttribute('src') === src) return;
      if (it.media) {
        it.media.classList.add('is-swapping');
        const done = () => { it.media.classList.remove('is-swapping'); it.img.removeEventListener('load', done); };
        it.img.addEventListener('load', done);
        setTimeout(() => it.media && it.media.classList.remove('is-swapping'), 400);
      }
      it.img.src = src;
    }
    function refreshSizes(it) {
      it.sizeEls.forEach((se) => {
        const size = se.dataset.size;
        const ok = it.variants && it.variants.find((x) =>
          x.size === size && (it.selColor == null || x.color === it.selColor) && x.available);
        se.disabled = !ok;
        se.classList.toggle('is-active', size === it.selSize);
      });
    }
    function refreshSwatches(it) {
      it.swatches.forEach((s) => s.classList.toggle('is-active', s.dataset.color === it.selColor));
    }
    function resolve(it) {
      const cta = it.card.querySelector('[data-card-cta]');
      const v = variantFor(it, it.selColor, it.selSize);
      if (v && v.available) {
        it.variantId = String(v.id);
        it.priceCents = v.price;
        it.image = v.image || colorImage(it, it.selColor) || it.image;
        if (it.priceEl) it.priceEl.textContent = fmt(v.price);
        if (cta) cta.disabled = false;
      } else if (cta && it.variants) {
        cta.disabled = true;
      }
    }
    const SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '4XL', '5XL'];
    function sizeRank(s) {
      const u = (s || '').toUpperCase().replace(/\s+/g, '');
      const i = SIZE_ORDER.indexOf(u);
      if (i !== -1) return i;
      const n = parseFloat(s);
      return isNaN(n) ? 500 : 100 + n;
    }
    function initPicker(it) {
      if (!it.variants) return; // fallback card
      if (it.sizeEls.length) {
        it.sizeEls.sort((a, b) => sizeRank(a.dataset.size) - sizeRank(b.dataset.size));
        const c = it.card.querySelector('[data-bundle-sizes]');
        if (c) it.sizeEls.forEach((se) => c.appendChild(se));
      }
      // Merchant-chosen default (card data attrs) → else the first available.
      const dCol = it.card.dataset.defaultColor || '';
      const dSize = it.card.dataset.defaultSize || '';
      let init = null;
      if (dCol || dSize) {
        init = it.variants.find((v) => (!dCol || v.color === dCol) && (!dSize || v.size === dSize) && v.available)
            || it.variants.find((v) => (!dCol || v.color === dCol) && (!dSize || v.size === dSize));
      }
      const first = init || firstAvailable(it);
      if (first) { it.selColor = first.color; it.selSize = first.size; }
      refreshSwatches(it);
      refreshSizes(it);
      resolve(it);
      if (it.selColor) swapImage(it, colorImage(it, it.selColor) || it.image);

      it.swatches.forEach((s) => {
        s.addEventListener('mouseenter', () => { if (hoverCapable.matches) swapImage(it, s.dataset.image); });
        s.addEventListener('click', (e) => {
          e.stopPropagation();
          it.selColor = s.dataset.color;
          refreshSwatches(it);
          const keep = it.variants.find((x) => x.color === it.selColor && x.size === it.selSize && x.available);
          if (!keep) {
            const fs = it.variants.find((x) => x.color === it.selColor && x.available);
            it.selSize = fs ? fs.size : it.selSize;
          }
          refreshSizes(it);
          resolve(it);
          swapImage(it, colorImage(it, it.selColor) || it.image);
          if (it.on) render();
        });
      });
      const colorsRow = it.card.querySelector('[data-bundle-colors]');
      if (colorsRow) colorsRow.addEventListener('mouseleave', () => {
        if (hoverCapable.matches && it.selColor) swapImage(it, colorImage(it, it.selColor) || it.image);
      });
      it.sizeEls.forEach((se) => {
        se.addEventListener('click', (e) => {
          e.stopPropagation();
          if (se.disabled) return;
          it.selSize = se.dataset.size;
          refreshSizes(it);
          resolve(it);
          if (it.on) render();
        });
      });
    }
    items.forEach(initPicker);

    /* ── Open / close ─────────────────────────────────────────────────── */
    function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(() => { open = null; render(); }, 220); }
    function cancelClose() { clearTimeout(closeTimer); }
    const desktopHover = () => hoverCapable.matches && !mobileQ.matches;

    // Hotspot dot — opens the active card for the current viewport.
    hotspots.forEach((h) => {
      const id = h.dataset.id;
      h.addEventListener('mouseenter', () => { if (desktopHover()) { const a = activeItem(id); if (a) { cancelClose(); open = a.cid; render(); } } });
      h.addEventListener('mouseleave', () => { if (desktopHover()) scheduleClose(); });
      h.addEventListener('click', () => {
        const a = activeItem(id); if (!a) return;
        cancelClose();
        if (desktopHover()) { open = a.cid; render(); return; }
        open = open === a.cid ? null : a.cid;
        render();
      });
    });

    // Per-card interactions.
    items.forEach((it) => {
      it.card.addEventListener('mouseenter', () => { if (desktopHover()) cancelClose(); });
      it.card.addEventListener('mouseleave', () => { if (desktopHover()) scheduleClose(); });
      const cta = it.card.querySelector('[data-card-cta]');
      if (cta) cta.addEventListener('click', (e) => { e.stopPropagation(); if (cta.disabled) return; it.on = !it.on; render(); });
      const closeBtn = it.card.querySelector('[data-card-close]');
      if (closeBtn) closeBtn.addEventListener('click', (e) => { e.stopPropagation(); open = null; render(); });
      // Quantity stepper for the selected variant.
      const qtyNum = it.card.querySelector('[data-qty-num]');
      const setQty = (n) => { it.qty = Math.max(1, n); if (qtyNum) qtyNum.textContent = it.qty; if (it.on) render(); };
      const dec = it.card.querySelector('[data-qty-dec]');
      const inc = it.card.querySelector('[data-qty-inc]');
      if (dec) dec.addEventListener('click', (e) => { e.stopPropagation(); setQty(it.qty - 1); });
      if (inc) inc.addEventListener('click', (e) => { e.stopPropagation(); setQty(it.qty + 1); });
    });

    if (selectedRow) {
      selectedRow.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-remove]');
        if (!btn) return;
        const it = items.find((x) => x.cid === btn.dataset.remove);
        if (it) { it.on = false; render(); }
      });
    }

    /* ── Render ───────────────────────────────────────────────────────── */
    function pillSub(it) {
      const bits = [it.selColor, it.selSize].filter(Boolean);
      if (it.qty > 1) bits.push('×' + it.qty);
      return bits.join(' · ');
    }
    function renderPills(active) {
      if (!selectedRow) return;
      const wanted = new Set(active.map((x) => x.cid));
      Array.from(selectedRow.children).forEach((el) => {
        if (!wanted.has(el.dataset.bundleItem)) { el.dataset.leaving = 'true'; setTimeout(() => el.remove(), 350); }
      });
      active.forEach((x) => {
        let el = selectedRow.querySelector(`[data-bundle-item="${x.cid}"]`);
        const sub = pillSub(x);
        if (!el) {
          el = document.createElement('div');
          el.className = 'bundle__pill';
          el.dataset.bundleItem = x.cid;
          el.innerHTML = `
            ${x.image ? `<img src="${x.image}" alt="${x.name}">` : ''}
            <span class="bundle__pill-body">
              <span class="bundle__pill-name">${x.name}</span>
              ${sub ? `<span class="bundle__pill-sub" data-pill-sub>${sub}</span>` : ''}
              <span class="bundle__pill-price" data-pill-price>${fmt(x.priceCents * x.qty)}</span>
            </span>
            <button type="button" class="bundle__pill-remove" data-remove="${x.cid}" aria-label="Remove">×</button>`;
          selectedRow.appendChild(el);
          requestAnimationFrame(() => { el.dataset.entered = 'true'; });
        } else {
          const im = el.querySelector('img'); if (im && x.image) im.src = x.image;
          const pr = el.querySelector('[data-pill-price]'); if (pr) pr.textContent = fmt(x.priceCents * x.qty);
          let su = el.querySelector('[data-pill-sub]');
          if (sub) {
            if (!su) { su = document.createElement('span'); su.className = 'bundle__pill-sub'; su.dataset.pillSub = ''; el.querySelector('.bundle__pill-name').after(su); }
            su.textContent = sub;
          } else if (su) su.remove();
        }
      });
    }

    function render() {
      hotspots.forEach((h) => {
        const a = activeItem(h.dataset.id);
        h.setAttribute('aria-pressed', a && open === a.cid ? 'true' : 'false');
        h.dataset.on = a && a.on ? 'true' : 'false';
      });
      cards.forEach((c) => { c.hidden = c.dataset.card !== open; });
      if (mobileCards) mobileCards.classList.toggle('is-open', open != null && mobileQ.matches);
      items.forEach((it) => {
        const cta = it.card.querySelector('[data-card-cta]');
        if (!cta) return;
        cta.dataset.on = it.on ? 'true' : 'false';
        cta.textContent = it.on ? 'Added to bundle ✓' : 'Add to bundle';
      });
      const active = items.filter((x) => x.on && isActive(x));
      const totalQty = active.reduce((s, x) => s + x.qty, 0);
      const totalCents = active.reduce((s, x) => s + x.priceCents * x.qty, 0);
      const listCents = Math.round(totalCents * listMul);
      if (totalEl) {
        const c = totalEl.querySelector('[data-count]');
        const l = totalEl.querySelector('[data-list]');
        const n = totalEl.querySelector('[data-now]');
        if (c) c.textContent = `${totalQty} ${totalQty === 1 ? 'piece' : 'pieces'} selected`;
        if (n) n.textContent = fmt(totalCents);
        if (l) { l.hidden = active.length < 3; l.textContent = fmt(listCents); }
      }
      renderPills(active);
    }

    /* ── Add the whole bundle to cart ─────────────────────────────────── */
    const addAll = root.querySelector('[data-bundle-add-all]');
    if (addAll) {
      addAll.addEventListener('click', async () => {
        const selected = items.filter((x) => x.on && isActive(x));
        const lines = selected.filter((x) => x.variantId).map((x) => ({ id: parseInt(x.variantId, 10), quantity: x.qty }));
        if (!lines.length) {
          if (window.abbaraToast) window.abbaraToast(selected.length ? 'These pieces have no linked product yet' : 'Select at least one piece');
          return;
        }
        const skipped = selected.length - lines.length;
        if (skipped > 0 && window.abbaraToast) window.abbaraToast(`${skipped} preview piece${skipped > 1 ? 's' : ''} skipped — link a product to add`);
        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: lines }),
            credentials: 'same-origin',
          });
          if (r.ok) {
            // Refresh the count + toast, but keep the shopper browsing — the
            // drawer opens only when they tap the cart icon.
            if (window.refreshCart) await window.refreshCart();
            const units = lines.reduce((s, l) => s + l.quantity, 0);
            if (window.abbaraToast) window.abbaraToast(`Added to cart · ${units} ${units === 1 ? 'piece' : 'pieces'}`);
            return;
          }
          const gated = r.status === 401 || r.status === 403 || (r.url && r.url.indexOf('/password') !== -1);
          if (!gated) {
            let msg = 'Could not add the bundle — please try again';
            try { const j = await r.json(); msg = j.description || j.message || msg; } catch (_) {}
            if (window.abbaraToast) window.abbaraToast(msg);
            return;
          }
        } catch (e) {
          if (window.abbaraToast) window.abbaraToast('Network error — please try again');
          return;
        }
        const back = new URL(window.location.href);
        back.searchParams.set('cart_added', String(lines.length));
        const form = document.createElement('form');
        form.action = '/cart/add';
        form.method = 'POST';
        form.style.display = 'none';
        lines.forEach((line, i) => {
          form.appendChild(hiddenInput(`items[${i}][id]`, line.id));
          form.appendChild(hiddenInput(`items[${i}][quantity]`, line.quantity));
        });
        form.appendChild(hiddenInput('return_to', back.pathname + back.search));
        document.body.appendChild(form);
        form.submit();
      });
    }
    function hiddenInput(name, value) {
      const el = document.createElement('input');
      el.type = 'hidden'; el.name = name; el.value = String(value);
      return el;
    }

    // Theme editor only: highlight the dot for the hotspot block the merchant
    // has selected, so they can see which one they're positioning/editing.
    if (window.Shopify && Shopify.designMode) {
      const clearSel = () => hotspots.forEach((h) => h.classList.remove('is-editor-selected'));
      document.addEventListener('shopify:block:select', (e) => {
        const h = e.target && e.target.closest ? e.target.closest('.bundle__hotspot') : null;
        if (!h || !root.contains(h)) return;
        clearSel();
        h.classList.add('is-editor-selected');
      });
      document.addEventListener('shopify:block:deselect', (e) => {
        const h = e.target && e.target.closest ? e.target.closest('.bundle__hotspot') : null;
        if (h && root.contains(h)) h.classList.remove('is-editor-selected');
      });
    }

    render();
  });
})();
